import { Card } from '@ocula/ui';
// TODO update logo to webp file
import Logo from '@ui/assets/brand/logo.png';
import { useState } from 'react';

import ContinueSessionComponent from './ContinueSessionComponent';
import SelectRegionComponent from './SelectRegionComponent';

import styles from './landingPage.css';

const LandingPage = () => {
  const previousSessionExists = localStorage.getItem('auth0Name');
  const [resumePreviousSession, setResumePreviousSession] = useState(!!previousSessionExists);

  return (
    <main className={styles.pageContainer}>
      <Card>
        <div className={styles.cardContainer}>
          <div className={styles.logoContainer}>
            <img alt="Ocula Technologies logo" className={styles.logo} src={Logo} />
          </div>
          {resumePreviousSession ? (
            <ContinueSessionComponent
              goToSelectRegion={() => {
                setResumePreviousSession(false);
              }}
            />
          ) : (
            <SelectRegionComponent
              goToContinueSession={() => {
                setResumePreviousSession(true);
              }}
            />
          )}
        </div>
      </Card>
    </main>
  );
};

export default LandingPage;
